import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { fadeUp } from "@/lib/motion";
import { WHY_CHOOSE, IMAGES } from "@/data/content";

const WhyChooseSection = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-[#F8FAFC] overflow-hidden" id="why-choose" data-testid="why-choose-section">
      <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />
      <div className="relative max-w-[1320px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              overline="Why Choose Us"
              title="Why Manufacturers Choose AutoDrive"
              description="A partner that removes uncertainty from certification and keeps your program moving."
            />
            <Reveal custom={3} className="mt-8 rounded-2xl overflow-hidden hidden lg:block">
              <img src={IMAGES.collaborate} alt="Engineering team collaborating on compliance analysis" className="w-full h-64 object-cover" loading="lazy" />
            </Reveal>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-5">
            {WHY_CHOOSE.map((w, i) => (
              <Reveal key={w.title} variants={fadeUp} custom={i % 2}>
                <div className="group flex gap-5 h-full rounded-2xl bg-white border border-slate-200 p-6 hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-900/5 transition-[transform,box-shadow] duration-300">
                  <span className="shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#0F172A] text-white group-hover:bg-[#1E40AF] transition-colors">
                    <w.icon className="w-5 h-5" strokeWidth={1.7} />
                  </span>
                  <div>
                    <h3 className="font-display font-semibold text-[#0F172A] text-lg">{w.title}</h3>
                    <p className="mt-1.5 text-sm text-slate-500 leading-relaxed">{w.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
